import moment from 'moment';

import {
  OPEN_QUICK_REPORT_MODAL,
  CLOSE_QUICK_REPORT_MODAL,
  OPEN_CUSTOM_REPORT_DELETE_MODAL,
  CLOSE_CUSTOM_REPORT_DELETE_MODAL,
  OPEN_LARGE_REPORT_EMAIL_MODAL,
  CLOSE_LARGE_REPORT_EMAIL_MODAL,
  UPDATE_CUSTOM_REPORTS_PAGINATION,
  UPDATE_CUSTOM_REPORTS_SEARCH,
  SELECT_CUSTOM_REPORT,
  SELECT_QUICK_REPORT,
  SELECT_REPORT_FILE_TYPE,
  SELECT_REPORT_TIME_RANGE,
  SELECT_REPORT_DATE_CHANGE,
  SELECT_REPORT_DATE_FOCUS_CHANGE,
  SELECT_REPORT_SINGLE_DATE_CHANGE,
  SELECT_REPORT_SINGLE_DATE_FOCUS_CHANGE,
  INCLUDE_EXTENDED_REPORT
} from '../actions';

const initialState = {
  fileFormats: ['CSV', 'XLS'], // Add in XLS afterwards
  showCustomReportDeleteModal: false,
  showQuickReportModal: false,
  showLargeReportEmailModal: false,
  includeExtendedAudit: true,
  quickReports: {
    reportSelected: {
      title: '',
      type: '',
      fileType: ''
    },
    timeRangeSelected: 'all',
    customTimeRange: {
      startDate: moment().subtract(1, 'week'),
      endDate: moment()
    },
    focusedInput: 'startDate',
    singleDate: moment(),
    singleDateFocused: true,
    options: {
      reports: [{
        title: 'Tickets',
        fileFormat: 'CSV',
        value: 'cost_items'
      }, {
        title: 'Add-ons',
        fileFormat: 'CSV',
        value: 'add_ons'
      }, {
        title: 'Orders',
        fileFormat: 'CSV',
        value: 'orders'
      }, {
        title: 'Cancellations',
        fileFormat: 'CSV',
        value: 'cancellations'
      }, {
        title: 'Account Activity',
        fileFormat: 'CSV',
        value: 'activity_report'
      }, {
        title: 'Ticket Type - Event Level',
        fileFormat: 'CSV',
        value: 'listings'
      }, {
        title: 'Ticket Type - Date/Time Level',
        fileFormat: 'CSV',
        value: 'events'
      }, {
        title: 'Chargeback',
        fileFormat: 'CSV',
        value: 'chargebacks'
      }, {
        title: 'Settlement',
        fileFormat: 'CSV',
        value: 'settlement'
      }, {
        title: 'Sales by Event',
        fileFormat: 'CSV',
        value: 'sales_by_event'
      }, {
        title: 'Timeslot Changes',
        fileFormat: 'CSV',
        value: 'timeslot_changes'
      }, {
        title: 'Waitlist',
        fileFormat: 'CSV',
        value: 'waitlist'
      }, {
        title: 'Rebate',
        fileFormat: 'CSV',
        value: 'rebates'
      }, {
        title: 'Audit',
        fileFormat: 'PDF',
        value: 'audit'
      }],
      timeRanges: [{
        title: 'All Transactions',
        value: 'all'
      }, {
        title: 'Past 30 Days',
        value: 'mtd'
      }, {
        title: 'Custom Date Range',
        value: 'custom'
      }, {
        title: 'Single Day',
        value: 'single'
      }],
    }
  },
  customReports: {
    pagination: {
      limit: 5,
      offset: 0,
      currentPage: 1
    },
    searchText: null,
    reportSelected: {
      id: '',
      fileType: ''
    },
  }
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {
    case OPEN_QUICK_REPORT_MODAL:
      const report = state.quickReports.options.reports.find(report => report.title == action.payload.reportSelectedId);
      return Object.assign({}, state, {
        ...state,
        showQuickReportModal: true,
        showCustomReportDeleteModal: false,
        showLargeReportEmailModal: false,
        quickReports: {
          ...state.quickReports,
          reportSelected: {
            title: action.payload.reportSelectedTitle + ' Report',
            value: report.value,
            fileFormat: report.fileFormat.toLowerCase()
          }
        }
      });

    case OPEN_CUSTOM_REPORT_DELETE_MODAL:
      return Object.assign({}, state, {
        ...state,
        showQuickReportModal: false,
        showCustomReportDeleteModal: true,
        showLargeReportEmailModal: false,
        customReports: {
          ...state.customReports,
          reportSelected: {
            id: action.payload
          }
        }
      });

    case OPEN_LARGE_REPORT_EMAIL_MODAL:
      return Object.assign({}, state, {
        ...state,
        showQuickReportModal: false,
        showCustomReportDeleteModal: false,
        showLargeReportEmailModal: true,
      });

    case SELECT_QUICK_REPORT:
      const report2 = state.quickReports.options.reports.find(report => report.title == action.payload.reportSelectedId);
      return Object.assign({}, state, {
        ...state,
        showQuickReportModal: false,
        showCustomReportDeleteModal: false,
        showLargeReportEmailModal: false,
        quickReports: {
          ...state.quickReports,
          reportSelected: {
            title: action.payload.reportSelectedTitle + ' Report',
            value: report2.value,
            fileFormat: report2.fileFormat.toLowerCase()
          }
        }
      });


    case UPDATE_CUSTOM_REPORTS_PAGINATION:
      const { limit, offset, currentPage } = action.payload;
      return Object.assign({}, state, {
        ...state,
        customReports: {
          ...state.customReports,
          pagination: {
            limit,
            offset,
            currentPage
          }
        }
      });

    case UPDATE_CUSTOM_REPORTS_SEARCH:
      const { searchText } = action.payload;
      return Object.assign({}, state, {
        ...state,
        customReports: {
          ...state.customReports,
          searchText
        }
      });

    case SELECT_REPORT_FILE_TYPE:
      switch (action.payload.reportType) {
        case 'custom': {
          return {
            ...state,
            customReports: {
              ...state.customReports,
              reportSelected: {
                ...state.customReports.reportSelected,
                id: action.payload.id,
              }
            }
          };
        }
        case 'quick':
          return Object.assign({}, state, {
            ...state,
            quickReports: {
              ...state.quickReports,
              options: {
                ...state.quickReports.options,
                reports: state.quickReports.options.reports.map(report => {
                  if (action.payload.id === report.title) {
                    return {
                      ...report,
                      fileFormat: action.payload.reportFileType
                    };
                  }
                  return report;
                })
              }
            }
          });
      }

    case INCLUDE_EXTENDED_REPORT:
      return Object.assign({}, state, {
        ...state,
        includeExtendedAudit: action.payload.includeExtendedAudit
      });

    case SELECT_REPORT_TIME_RANGE:
      return Object.assign({}, state, {
        ...state,
        quickReports: {
          ...state.quickReports,
          timeRangeSelected: action.payload
        }
      });

    case SELECT_REPORT_DATE_CHANGE:
      return Object.assign({}, state, {
        ...state,
        quickReports: {
          ...state.quickReports,
          customTimeRange: {
            startDate: action.payload.startDate,
            endDate: action.payload.endDate
          }
        }
      });

    case SELECT_REPORT_DATE_FOCUS_CHANGE:
      return Object.assign({}, state, {
        ...state,
        quickReports: {
          ...state.quickReports,
          focusedInput: action.payload
        }
      });

    case SELECT_REPORT_SINGLE_DATE_CHANGE:
      return Object.assign({}, state, {
        ...state,
        quickReports: {
          ...state.quickReports,
          singleDate: action.payload
        }
      });

    case SELECT_REPORT_SINGLE_DATE_FOCUS_CHANGE:
      return Object.assign({}, state, {
        ...state,
        quickReports: {
          ...state.quickReports,
          singleDateFocused: true
        }
      });

    case CLOSE_QUICK_REPORT_MODAL:
      return Object.assign({}, initialState, {
        ...state,
        showQuickReportModal: false,
        quickReports: {
          ...initialState.quickReports,
          options: {
            ...initialState.quickReports.options,
            reports: state.quickReports.options.reports
          }
        }
      });

    case CLOSE_CUSTOM_REPORT_DELETE_MODAL:
      return Object.assign({}, state, {
        ...state,
        showCustomReportDeleteModal: false
      });

    case CLOSE_LARGE_REPORT_EMAIL_MODAL:
      return Object.assign({}, state, {
        ...state,
        showLargeReportEmailModal: false
      });

    case SELECT_CUSTOM_REPORT: {
      return {
        ...state,
        customReports: {
          ...state.customReports,
          reportSelected: {
            id: action.payload.id,
            fileType: action.payload.fileType
          }
        }
      };
    }


    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/reports/reducers/home.js